// extracted by mini-css-extract-plugin
module.exports = {"tooltipContent":"_1qt_6cuT","closingWrapper":"_13nYm36X","manual":"_2C6brPaL"};